import TableEditableComponent from 'components/elements/table/table';
import { ColumnDataType } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';

interface Props {
  value: any;
}

export default function ProductTable(props: Props) {
  const { t } = useTranslation();
  const name = 'approvalable.tourProducts';

  const columns = [
    {
      header: t('product:product-variant'),
      accessorKey: 'productVariantName',
      minSize: 400,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:stock'),
      accessorKey: 'stock',
      minSize: 100,
      dataType: ColumnDataType.number,
    },
    {
      header: t('common:avg_cogs'),
      accessorKey: 'avgCogs',
      minSize: 100,
      dataType: ColumnDataType.number,
    },
    {
      header: t('common:quantity'),
      accessorKey: 'qty',
      minSize: 100,
      dataType: ColumnDataType.number,
    },
    {
      header: t('common:description'),
      accessorKey: 'description',
      minSize: 200,
      dataType: ColumnDataType.text,
    },
  ];

  return (
    <div style={{ width: '100' }}>
      <TableEditableComponent
        columns={columns}
        data={props.value[name]}
        dispatch={() => {}}
        disabled
        name={name}
      />
    </div>
  );
}
